<template>
  <div class="dm-corp-page page-trial-unit">
    <header-topbar />

    <div class="main-container m-container">
      <h3 class="m-title">申请试用企业智能心理服务平台</h3>

      <el-form
        class="m-form"
        label-position="top"
        ref="infoForm"
        :model="info"
        :rules="rules"
        @submit.native.prevent
      >
        <el-form-item label="组织名称" prop="companyName">
          <el-input
            type="text"
            :maxlength="50"
            v-model="info.companyName"
            placeholder="请填写组织/企业全称"
          ></el-input>
        </el-form-item>

        <el-form-item label="组织规模" prop="companyNum">
          <el-select class="block" v-model="info.companyNum" placeholder="请选择">
            <el-option
              v-for="item in unitScale"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属区域" prop="areaId">
          <el-cascader class="block" :props="areaProps" v-model="info.areaId"></el-cascader>
        </el-form-item>

        <el-form-item label="主营业务" prop="mainBusiness">
          <el-input
            type="text"
            :maxlength="50"
            v-model="info.mainBusiness"
            placeholder="如：心理咨询、培训、设计等"
          ></el-input>
        </el-form-item>

        <el-form-item label="担任职位" prop="bearPosition">
          <el-input
            type="text"
            :maxlength="50"
            v-model="info.bearPosition"
            placeholder="申请人在该企业担任的职位，如：CEO、运营"
          ></el-input>
        </el-form-item>

        <el-form-item label="申请人姓名" prop="contactNickname">
          <el-input type="text" :maxlength="20" v-model="info.contactNickname"></el-input>
        </el-form-item>

        <!-- adminName 账号名同步到申请人手机号 -->
        <el-form-item label="申请人手机号码（申请成功后作为 登录账号）" prop="adminPhone">
          <el-input type="text" :maxlength="20" v-model="info.adminPhone"></el-input>
        </el-form-item>

        <el-form-item label="申请人邮箱" prop="email">
          <el-input type="text" :maxlength="50" v-model="info.email"></el-input>
        </el-form-item>

        <el-form-item label="登录密码" prop="adminPassword">
          <el-input
            type="text"
            :maxlength="20"
            v-model="info.adminPassword"
            placeholder="请设置你的登录密码，申请成功后用于登录管理台"
          ></el-input>
        </el-form-item>

        <el-form-item label="">
          <div class="m-btns">
            <el-button @click="gotoBack">取消</el-button>
            <el-button type="primary" :loading="saving" @click="submitForm('infoForm')"
              >提交</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import HeaderTopbar from 'components/common/HeaderTopbar'
import { getAreaData, postTrialUnitApplyV2 } from '@/api/index.js'

const unitScale = [
  {
    value: '0~20人',
    label: '0~20人'
  },
  {
    value: '20~99人',
    label: '20~99人'
  },
  {
    value: '100~499人',
    label: '100~499人'
  },
  {
    value: '500~999人',
    label: '500~999人'
  },
  {
    value: '10000人以上',
    label: '10000人以上'
  }
]

export default {
  name: 'Unit',
  components: { HeaderTopbar },

  data() {
    return {
      saving: false,
      info: {
        areaId: []
      },
      rules: {
        companyName: [{ required: true, message: '请填写组织名称', trigger: 'change' }],
        companyNum: [{ required: true, message: '请选择组织规模', trigger: 'change' }],
        areaId: [{ required: true, message: '请选择所属区域', trigger: 'change' }],
        bearPosition: [
          { required: true, message: '请填写您在该公司担任的职位', trigger: 'change' }
        ],
        contactNickname: [{ required: true, message: '我们应该如何称呼您？', trigger: 'change' }],
        adminPhone: [
          { required: true, message: '请填写手机号', trigger: 'change' },
          { pattern: /^1\d{10}$/, message: '手机号格式不正确', trigger: 'change' }
        ],
        email: [
          { required: true, message: '请填写邮箱地址', trigger: 'change' },
          { type: 'email', message: '请填写正确的邮箱地址', trigger: 'change' }
        ],
        adminPassword: [
          { required: true, message: '请填写登录密码', trigger: 'change' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'change' }
        ]
      },

      unitScale: unitScale,
      areaProps: {
        lazy: true,
        lazyLoad: this.areaLazyLoad
      }
    }
  },

  computed: {
    // 渠道归属机构code
    inviteChannelCode() {
      return this.$route.query['invite_channel_code']
    },
    // 商务code
    busCode() {
      return this.$route.query['cod']
    },
    // 模版code - 复制该渠道内容
    tplCode() {
      return this.$route.query['tplCod']
    }
  },

  methods: {
    gotoBack() {
      window.history.back()
    },

    areaLazyLoad(node, resolve) {
      const { level, label, value } = node
      getAreaData(level === 0 ? 1 : value, 1)
        .then(res => {
          let areaList = res.data
          if (areaList.length === 0) {
            areaList = [{ id: value, name: label }]
          }
          const nodes = areaList.map(item => ({
            value: item.id,
            label: item.name,
            leaf: level >= 2
          }))
          resolve(nodes)
        })
        .catch(() => {})
    },

    submitForm(formRef) {
      this.$refs[formRef].validate(valid => {
        if (!valid) {
          return false
        }
        this.saving = true
        const areaId = this.info.areaId ? this.info.areaId[this.info.areaId.length - 1] : ''
        postTrialUnitApplyV2({
          ...this.info,
          areaId,
          adminName: this.info.adminPhone,
          inviteChannelCode: this.inviteChannelCode,
          businessCode: this.busCode,
          tplCode: this.tplCode
        })
          .then(() => {
            this.saving = false
            this.$router.push({
              name: 'trial.new.status',
              query: {
                flag: 'submit',
                invite_channel_code: this.inviteChannelCode,
                cod: this.busCode,
                tplCod: this.tplCode
              }
            })
          })
          .catch(error => {
            this.saving = false
            let messageText = ''
            if (error.response && error.response.data.msg) {
              messageText = 'ERROR：' + error.response.data.msg
            } else {
              messageText = 'ERROR：提交失败，请检查申请表格信息，需要帮助请联系客服'
            }
            this.$message.error(messageText)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-trial-unit {
  padding-bottom: 20px;
  .m-container {
    padding-top: 60px;
  }

  .m-title {
    margin-bottom: 30px;
    text-align: center;
    font-size: 22px;
    font-weight: 600;
    line-height: 22px;
  }

  .m-form {
    margin: 0 auto 30px;
    max-width: 380px;

    .block {
      display: block;
    }

    .el-form-item__label {
      font-weight: bold;
      line-height: 22px;
    }

    .m-btns {
      padding-top: 10px;
      text-align: center;
      .el-button + .el-button {
        margin-left: 20px;
      }
    }
  }
}
</style>
